import moment from 'moment'

import {
  BRAND_AMBASSADORS_STATUS_TYPE_TO_ENUM,
  GLOBAL_SEARCH,
  ROLE_CLIENT,
  ROLE_CLIENT_ADMIN,
  ROLE_DISTRIBUTOR,
  ROLE_SPY,
} from '../../shared/constants'

import { urlSet, urlRemove } from '../URL'
import { getWeekDayIndex, getLongWeekDay } from 'shared/libraries/utils/date'
import { formatStringToFirstUpperCase } from '../Formatters'

export const getSuggestionValue = ({ label, item }) => {
  if (label === GLOBAL_SEARCH.MISSION) {
    return `Mission #${item.id}`
  }
  if (label === GLOBAL_SEARCH.USER) {
    return `${item.firstName}  ${item.lastName} (${item.role})(${
      BRAND_AMBASSADORS_STATUS_TYPE_TO_ENUM[item.status]
    })`
  }
  if (
    [
      GLOBAL_SEARCH.CLIENT,
      GLOBAL_SEARCH.CAMPAIGN,
      GLOBAL_SEARCH.INVENTORY_CODE,
      GLOBAL_SEARCH.PARTICIPANT,
      GLOBAL_SEARCH.CITY,
      GLOBAL_SEARCH.LOCATION,
    ].includes(label)
  ) {
    return item.name
  }

  return ''
}

export const generateSuggestionURL = ({ label, item }) => {
  if (label === GLOBAL_SEARCH.MISSION) {
    const { id } = item
    return `/dashboard/mission/${id}`
  }
  if (label === GLOBAL_SEARCH.CAMPAIGN) {
    const { id } = item
    return `/dashboard/campaigns/${id}/dashboard`
  }
  if (label === GLOBAL_SEARCH.LOCATION) {
    const { name, city_id } = item
    return `/dashboard/cities/${city_id}/locations/handtohand?tableSearch=${name}`
  }
  if (label === GLOBAL_SEARCH.USER) {
    if (item.role === ROLE_DISTRIBUTOR) {
      const { id, CityId } = item
      return `/dashboard/cities/${CityId}/ambassadors/${id}`
    } else if (item.role === ROLE_SPY) {
      const { id, CityId } = item
      return `/dashboard/cities/${CityId}/spies/${id}`
    } else {
      const { id } = item
      return `/dashboard/users/${id}`
    }
  }
  if (label === GLOBAL_SEARCH.CLIENT) {
    const { id } = item
    return `/dashboard/clients/${id}`
  }
  if (label === GLOBAL_SEARCH.INVENTORY_CODE) {
    const {
      name,
      movements: { related_city = false },
    } = item
    return `/dashboard/cities/${related_city}/inventory?tableSearch=${name}`
  }
}

export const getSectionSuggestions = section => {
  return section.results
}
export const getMasterScheduleAndGlobalPlanningFiltersPresets = ({
  countryResponse,
  currentTimeOfDay = 'LUNCH',
  userRole,
}) => {
  const timeOfDay = formatStringToFirstUpperCase(currentTimeOfDay)
  return [
    {
      label: 'No Preset',
      action: filters => {
        filters.map(f => {
          f.selectedValue = null
          f.onChange()
          if (f.onChangeMulti) f.onChangeMulti([])
          urlRemove(f.label)
          return f
        })
      },
    },
    ...([ROLE_CLIENT, ROLE_CLIENT_ADMIN].includes(userRole)
      ? []
      : [
          {
            label: 'No-Show',
            action: filters => {
              filters.map(f => {
                f.selectedValue = null
                f.onChange('noShow')
                if (f.onChangeMulti) f.onChangeMulti([])
                urlRemove(f.label)
                return f
              })
            },
          },
        ]),
    {
      label: 'Live Missions',
      action: filters => {
        const dateTime = new Date()
        const dateWeekNumber = moment(dateTime).isoWeek()
        const today = getLongWeekDay(getWeekDayIndex(dateTime))

        filters.map(f => {
          f.selectedValue = null
          f.onChange()
          if (f.onChangeMulti) f.onChangeMulti([])
          urlRemove(f.label)

          if (f.label == 'Week') {
            f.selectedValue = `W${dateWeekNumber}`
            f.onChange(`W${dateWeekNumber}`)
            if (f.onChangeMulti) f.onChangeMulti([`W${dateWeekNumber}`])
            urlSet('Week', `W${dateWeekNumber}`)
          }
          if (f.label == 'Day of week') {
            f.selectedValue = today
            f.onChange(today)
            if (f.onChangeMulti) f.onChangeMulti([today])
            urlSet('Day of week', today)
          }
          if (f.label == 'Time of day') {
            f.selectedValue = timeOfDay
            f.onChange(timeOfDay)
            if (f.onChangeMulti) f.onChangeMulti([timeOfDay])
            urlSet('Time of day', timeOfDay)
          }
          return f
        })
      },
    },
    {
      label: "Yesterday's missions",
      action: filters => {
        const dateTime = new Date()
        let dateWeekNumber = moment(dateTime).isoWeek()

        const yesterday = getLongWeekDay(
          getWeekDayIndex(dateTime) == 0 ? 6 : getWeekDayIndex(dateTime) - 1,
        )

        if (yesterday === 'Sunday') {
          dateWeekNumber -= 1
        }

        filters.map(f => {
          f.selectedValue = null
          f.onChange()
          if (f.onChangeMulti) f.onChangeMulti([])
          urlRemove(f.label)

          if (f.label == 'Week') {
            f.selectedValue = `W${dateWeekNumber}`
            f.onChange(`W${dateWeekNumber}`)
            if (f.onChangeMulti) f.onChangeMulti([`W${dateWeekNumber}`])
            urlSet('Week', `W${dateWeekNumber}`)
          }
          if (f.label == 'Day of week') {
            f.selectedValue = yesterday
            f.onChange(yesterday)
            if (f.onChangeMulti) f.onChangeMulti([yesterday])
            urlSet('Day of week', yesterday)
          }
          return f
        })
      },
    },
    {
      label: "Today's missions",
      action: filters => {
        const dateTime = new Date()
        const dateWeekNumber = moment(dateTime).isoWeek()
        const today = getLongWeekDay(getWeekDayIndex(dateTime))

        filters.map(f => {
          f.selectedValue = null
          f.onChange()
          if (f.onChangeMulti) f.onChangeMulti([])
          urlRemove(f.label)

          if (f.label == 'Week') {
            f.selectedValue = `W${dateWeekNumber}`
            f.onChange(`W${dateWeekNumber}`)
            if (f.onChangeMulti) f.onChangeMulti([`W${dateWeekNumber}`])
            urlSet('Week', `W${dateWeekNumber}`)
          }
          if (f.label == 'Day of week') {
            f.selectedValue = today
            f.onChange(today)
            if (f.onChangeMulti) f.onChangeMulti([today])
            urlSet('Day of week', today)
          }
          return f
        })
      },
    },

    {
      label: "Tomorrow's missions",
      action: filters => {
        const dateTime = new Date()
        let dateWeekNumber = moment(dateTime).isoWeek()
        const tomorrow = getLongWeekDay(getWeekDayIndex(dateTime) + 1)
        if (tomorrow === 'Monday') {
          dateWeekNumber += 1
        }

        filters.map(f => {
          f.selectedValue = null
          f.onChange()
          if (f.onChangeMulti) f.onChangeMulti([])
          urlRemove(f.label)

          if (f.label == 'Week') {
            f.selectedValue = `W${dateWeekNumber}`
            f.onChange(`W${dateWeekNumber}`)
            if (f.onChangeMulti) f.onChangeMulti([`W${dateWeekNumber}`])
            urlSet('Week', `W${dateWeekNumber}`)
          }
          if (f.label == 'Day of week') {
            f.selectedValue = tomorrow
            f.onChange(tomorrow)
            if (f.onChangeMulti) f.onChangeMulti([tomorrow])
            urlSet('Day of week', tomorrow)
          }
          return f
        })
      },
    },
  ]
}
